import { createAction } from '@reduxjs/toolkit'

import { IntegrationType } from 'common/actions/integrations/common/constants/IntegrationType'
import { IThunkAction } from 'common/core/interfaces/actions'
import { getConnectedIntegrations } from 'common/core/selectors/appSelectors'
import { Integration } from 'shared/api/common/schemas/integration'
import { commonIntegrationApi } from 'shared/api/requests/integrations/common'
import { createAsyncAction } from 'shared/lib/redux'
import { anotherTabNotificationsListener } from 'utils/services/notificationsService'

import { getIntegration } from '../selectors'

interface IntegrationDataUpdatedSocket {
  actor: number
  client_id: null
  event: string
  model?: Integration
}

export const ensureIntegration = (type: IntegrationType): IThunkAction => {
  return (dispatch, getState) => {
    const state = getState()
    const connectedIntegrations = getConnectedIntegrations(state)
    const isIntegrationConnected = Boolean(connectedIntegrations?.[type])
    const isIntegrationAlreadyFetched = Boolean(getIntegration(state, type)?.status)

    if (isIntegrationConnected && !isIntegrationAlreadyFetched) {
      dispatch(fetchIntegration(type))
    }
  }
}

export const fetchIntegration = createAsyncAction(
  'integrations/fetchIntegration',
  async (type: IntegrationType) => {
    const response = await commonIntegrationApi.getIntegration({ query: { type } })
    return response.data
  },
)

export const disconnectIntegration = createAsyncAction(
  'integrations/disconnectIntegration',
  async (type: IntegrationType) => {
    const response = await commonIntegrationApi.disconnectIntegration({ body: { type } })
    return response.data
  },
)

export const connectIntegrationByToken = createAsyncAction(
  'integrations/connectIntegrationByToken',
  async ({
    type,
    token,
    additionalData,
  }: {
    type: IntegrationType
    token?: string
    additionalData?: SafeUnknownObject
  }) => {
    const body = additionalData ? { type, token, additional_data: additionalData } : { type, token }
    const response = await commonIntegrationApi.connectIntegrationByToken({ body })
    return response.data
  },
)

export const integrationUpdatedNotification = createAction<{ integration: Integration }>(
  'integrations/integrationUpdatedNotification',
)

anotherTabNotificationsListener.on(
  'integration_data_updated',
  (data: IntegrationDataUpdatedSocket, dispatch) => {
    if (data?.model) {
      dispatch(integrationUpdatedNotification({ integration: data?.model }))
    }
  },
)
